export default __webpack_public_path__ + "static/media/visibility.ecc755e7.svg";